import AlertsPage from '../client/Alerts';

export default function MspAlerts() {
  return <AlertsPage isMSP={true} />;
}
